
  import { COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';

  export default {
    data () {
      return {
        interval: null,
        locationOpened: false,
        width: 0
      };
    },
    computed: {
      cookieObject () {
        return this.$cookies.get(COOKIE_SELECTED_PRODUCT);
      },

      isRaisinProduct () {
        return this.cookieObject && this.cookieObject.plan.includes('Raisin');
      }
    },
    mounted () {
      if (!this.cookieObject || !this.cookieObject.link) return;
      this.interval = setInterval(_ => {
        this.width = Math.min(this.width + 2, 100);
        if (this.width >= 20 && !this.locationOpened) {
          this.locationOpened = true;
          clearInterval(this.interval);
          delete this.interval;
          window.location.href = this.cookieObject.link;
        }
      }, 300);
      this.$store.dispatch('matomo/trackProceedToProvider', {name: `Plan - ${this.cookieObject.institution}: ${this.cookieObject.plan}`});
      this.$cookies.remove(COOKIE_SELECTED_PRODUCT);
    }
  };
